import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { ImageInfoDetailBoxComponent } from './image-info-detail-box.component';
import { KYMW1600Model } from '../kymw1600.model';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

/**
 * 画面情報詳細ボックス部品 モジュール設定クラス
 *
 * @export ImageInfoDetailBoxModule
 * @class ImageInfoDetailBoxModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule,
  ],
  declarations: [
    ImageInfoDetailBoxComponent,
  ],
  providers: [
    KYMW1600Model,
  ],
  exports: [
    ImageInfoDetailBoxComponent,
  ]
})
export class ImageInfoDetailBoxModule {

}
